/*
 * @file Helper to get the correct reaction state from backend's data and what's currently in the frontend
 */
import { JsonAPIResource, Reaction } from '@padlet/arvo'
import { idsToDeleteInPage } from 'vuexstore/helpers/pagination_reconcile'

type ReactionId = string | number

// reconcile newly fetched reaction data with current state to get the correct state
function reconcileReactionsAfterFetch({
  context,
  newReactions,
  isFirstPage,
  isLastPage,
  shouldResetState,
}): Record<ReactionId, Reaction> {
  const { state, getters } = context
  const isOnlyPage = isFirstPage && isLastPage
  const newReactionEntities = shouldResetState || isOnlyPage ? {} : { ...state.reactionEntities }

  // we are paginating the reaction API by id so fetchedData only contains 1 page
  // during auto refresh, if a reaction id that's supposed to be in the current page exists in the current state but not in fetchedData means it has been deleted
  // => we have to remove it from newReactionEntities
  if (
    !shouldResetState && // we are only updating the state, i.e auto refresh or appending new page
    getters.isIntialReactionsLoadDone && // Don't try to remove anything when the first page load is not done
    newReactions.length
  ) {
    const idsToDelete = idsToDeleteInPage(isFirstPage, isLastPage, newReactions, newReactionEntities)
    idsToDelete.forEach(id => {
      delete newReactionEntities[id]
    })
  }

  newReactions.forEach(reactionData => {
    const reaction = reactionData.attributes
    newReactionEntities[reaction.id] = reaction
  })

  return newReactionEntities
}

export { reconcileReactionsAfterFetch }
